// extracted by mini-css-extract-plugin
export default {"hideScrollBar":"wdFd3","dragRailOuterContainer":"_1AlXV","dragRailInnerContainer":"_21lD9","grabbing":"_2GYqw"};